import { formatCompanyDateTime } from "@/lib/companyTime";
export function formatSessionDate(value?: string): string {
  if (!value) return "";
  try {
    return formatCompanyDateTime(value, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return value;
  }
}
